import { SubscriptionPlanNameEnum } from 'types/users.types';

export type SubscriptionFreePlan = typeof subscriptionFreePlans[number];
export const subscriptionFreePlans = ['eu.accountable.free'] as const;

export type SubscriptionTrialPlan = typeof subscriptionTrialPlans[number];
export const subscriptionTrialPlans = ['eu.accountable.trial1'] as const;

export type SubscriptionBasicPlan = typeof subscriptionBasicPlans[number];
export const subscriptionBasicPlans = [
  'eu.accountable.basic1',
  'eu.accountable.basic12',
] as const;

export type SubscriptionProPlan = typeof subscriptionProPlans[number];
export const subscriptionProPlans = [
  'eu.accountable.pro1',
  'eu.accountable.pro12',
] as const;
export const subscriptionProMaxPlans = [
  'eu.accountable.pro_max1',
  'eu.accountable.pro_max12',
] as const;
export type SubscriptionProMaxPlan = typeof subscriptionProMaxPlans[number];
export const subscriptionSmallPlans = [
  'eu.accountable.small1',
  'eu.accountable.small12',
] as const;
export type SubscriptionSmallPlan = typeof subscriptionSmallPlans[number];
export const subscriptionGrowMaxPlans = [
  'eu.accountable.small_max1',
  'eu.accountable.small_max12',
] as const;
export type SubscriptionGrowMaxPlan = typeof subscriptionGrowMaxPlans[number];
export const subscriptionEInvoicingPlans = [
  'eu.accountable.e_invoicing1',
  'eu.accountable.e_invoicing12',
] as const;
export type SubscriptionEInvoicingPlan =
  typeof subscriptionEInvoicingPlans[number];
export const subscriptionBookkeepingPlans = [
  'eu.accountable.bookkeeping1',
  'eu.accountable.bookkeeping12',
] as const;
export type SubscriptionBookkeepingPlan =
  typeof subscriptionBookkeepingPlans[number];
export const subscriptionTaxesPlans = [
  'eu.accountable.taxes1',
  'eu.accountable.taxes12',
] as const;
export type SubscriptionTaxesPlan = typeof subscriptionTaxesPlans[number];
export const subscriptionMaxPlans = [
  'eu.accountable.max1',
  'eu.accountable.max12',
] as const;
export type SubscriptionMaxPlan = typeof subscriptionMaxPlans[number];
export const subscriptionTandemPlans = ['eu.accountable.tandem12'] as const;
export type SubscriptionTandemPlan = typeof subscriptionTandemPlans[number];

export type SubscriptionPaidPlan = typeof subscriptionPaidPlans[number];
export const subscriptionPaidPlans = [
  ...subscriptionBasicPlans,
  ...subscriptionProPlans,
  ...subscriptionSmallPlans,
  ...subscriptionProMaxPlans,
  ...subscriptionGrowMaxPlans,
  ...subscriptionTandemPlans,
  ...subscriptionEInvoicingPlans,
  ...subscriptionBookkeepingPlans,
  ...subscriptionTaxesPlans,
  ...subscriptionMaxPlans,
] as const;

export const subscriptionPaidFranchiseePlans = [
  ...subscriptionSmallPlans,
  ...subscriptionGrowMaxPlans,
  ...subscriptionEInvoicingPlans,
  ...subscriptionBookkeepingPlans,
  ...subscriptionTaxesPlans,
  ...subscriptionMaxPlans,
] as const;

export type SubscriptionPaidFranchiseePlan =
  typeof subscriptionPaidFranchiseePlans[number];

export type SubscriptionAmbassadorPlan =
  typeof subscriptionAmbassadorPlans[number];
export const subscriptionAmbassadorPlans = [
  'eu.accountable.ambassador',
] as const;

export type SubscriptionNoWebAccessPlan =
  typeof subscriptionNoWebAccessPlans[number];
export const subscriptionNoWebAccessPlans = [
  'eu.accountable.free',
  'eu.accountable.basic1',
  'eu.accountable.basic12',
] as const;

export type StripeSubscriptionPlan = typeof stripeSubscriptionPlans[number];
export const stripeSubscriptionPlans = [
  ...subscriptionFreePlans,
  ...subscriptionTrialPlans,
  ...subscriptionPaidPlans,
  ...subscriptionAmbassadorPlans,
] as const;

export type SubscriptionManualPlatform =
  typeof subscriptionManualPlatforms[number];
export const subscriptionManualPlatforms = ['manual'] as const;

export type SubscriptionMobilePlatform =
  typeof subscriptionMobilePlatforms[number];
export const subscriptionMobilePlatforms = [
  'apple' /* legacy */,
  'ios' /* legacy */,
  'android' /* legacy */,
  'qonversion',
] as const;

export type SubscriptionWebPlatform = typeof subscriptionWebPlatforms[number];
export const subscriptionWebPlatforms = ['stripe', 'stripe-otp'] as const;

export type SubscriptionPromoPlatform =
  typeof subscriptionPromoPlatforms[number];
export const subscriptionPromoPlatforms = ['ING'] as const;

export type SubscriptionPlatform = typeof subscriptionPlatforms[number];
export const subscriptionPlatforms = [
  ...subscriptionManualPlatforms,
  ...subscriptionMobilePlatforms,
  ...subscriptionWebPlatforms,
  ...subscriptionPromoPlatforms,
] as const;

export const plans_order = {
  [SubscriptionPlanNameEnum.free]: 0,
  [SubscriptionPlanNameEnum.trial1]: 0,
  [SubscriptionPlanNameEnum.ambassador]: 0,
  [SubscriptionPlanNameEnum.basic1]: 1,
  [SubscriptionPlanNameEnum.basic12]: 1,
  [SubscriptionPlanNameEnum.small1]: 3,
  [SubscriptionPlanNameEnum.small12]: 3,
  [SubscriptionPlanNameEnum.pro1]: 3,
  [SubscriptionPlanNameEnum.pro12]: 3,
  [SubscriptionPlanNameEnum.pro_max1]: 4,
  [SubscriptionPlanNameEnum.pro_max12]: 4,
  [SubscriptionPlanNameEnum.small_max1]: 4,
  [SubscriptionPlanNameEnum.small_max12]: 4,
  [SubscriptionPlanNameEnum.tandem12]: 5,
  [SubscriptionPlanNameEnum.e_invoicing1]: 6,
  [SubscriptionPlanNameEnum.e_invoicing12]: 7,
  [SubscriptionPlanNameEnum.bookkeeping1]: 8,
  [SubscriptionPlanNameEnum.bookkeeping12]: 9,
  [SubscriptionPlanNameEnum.taxes1]: 10,
  [SubscriptionPlanNameEnum.taxes12]: 11,
  [SubscriptionPlanNameEnum.max1]: 12,
  [SubscriptionPlanNameEnum.max12]: 13,
} as const;
